
import { TypeOfNotification } from '../interfaces';
import { useStore } from '../store';
import { defineComponent, computed } from 'vue';

export default defineComponent({
    name: 'BaseNotification',
    data() {
        return {
            classAlert: {
                [TypeOfNotification.SUCESSO]: 'notification__success',
                [TypeOfNotification.ATENCAO]: 'notification__warning',
                [TypeOfNotification.FALHA]: 'notification__danger',
            },
        };
    },

    setup() {
        const store = useStore();

        return {
            notifications: computed(() => store.getters.notifications),
        };
    },
});
